import { fork } from 'redux-saga/effects';

import * as appointmentList from './requests/appointment-list-req';
import * as changeRoom from './requests/change-room-req';
import * as locations from './requests/locations-req';
import * as changeStatus from './requests/change-status-req';
import * as changePaidStatus from './requests/change-paid-status-req';
import * as pinAppointment from './requests/pin-req';
import * as validatePatientInfo from './requests/validate-patient-info-req';
import * as appointmentLocations from './requests/appointment-locations-req';
import * as createAppointmentReq from './requests/create-appointment-req';
import * as currentAppointmentDetailsReq from './requests/appointment-details-req';
import reloadOnFilterChange from './sagas/reload-on-filter-change';
import realTimeCreate from './sagas/real-time-create';
import realTimeUpdate from './sagas/real-time-update';
import intervalSaga from './sagas/interval-saga';
import savePatientInfoSaga from './sagas/save-patient-info-saga';
import changeStatusSaga from './sagas/change-status-saga';
import appointmentDetailsSaga from './sagas/appointment-details-saga';
import fetchFilteredAppointmentsSaga from './sagas/fetch-filtered-appointments-saga';

export default function* dependentManagementRootSaga() {
  yield fork(changePaidStatus.watcher);
  yield fork(appointmentList.watcher);
  yield fork(pinAppointment.watcher);
  yield fork(changeStatus.watcher);
  yield fork(changeRoom.watcher);
  yield fork(locations.watcher);
  yield fork(reloadOnFilterChange);
  yield fork(changeStatusSaga);
  yield fork(realTimeCreate);
  yield fork(realTimeUpdate);
  yield fork(intervalSaga);
}

export const dashboardSaga = function* dashboardSaga() {
  yield fork(validatePatientInfo.watcher);
  yield fork(appointmentLocations.watcher);
  yield fork(createAppointmentReq.watcher);
  yield fork(currentAppointmentDetailsReq.watcher);
  yield fork(appointmentDetailsSaga);
  yield fork(savePatientInfoSaga);
  yield fork(fetchFilteredAppointmentsSaga);
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/root-saga.js